import { ChangeDetectionStrategy, Component, HostListener, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export type CustomButtonsParams = ICellRendererParams & {
    onClick: (cellRendererParams?: ICellRendererParams, icon?: string) => void;
    visible?: boolean;
    tooltip?: string;
    checkValue?: string;
    matIcon?: string;
    activeClass?: boolean;
};

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'se-button-cell-renderer',
    templateUrl: './button-cell-renderer.component.html',
    styleUrls: ['./button-cell-renderer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatButtonModule, MatIconModule, TranslateModule],
})
export class ButtonCellRendererComponent implements ICellRendererAngularComp {
    onClick: (cellRendererParams: ICellRendererParams, icon: string) => void = () => null;
    private readonly params = signal<CustomButtonsParams | null>(null);
    readonly icon = signal<string>('');
    readonly visible = signal<boolean>(false);
    readonly tooltip = signal<string>('');
    readonly activeClass = signal<boolean>(false);

    agInit(params: CustomButtonsParams): void {
        this.params.set(params);
        this.icon.set(params.matIcon ?? '');
        this.visible.set(!!params.checkValue ? !!params.value : true);
        this.onClick = params.onClick;
        this.tooltip.set(params.tooltip ?? '');
        this.activeClass.set(!!params.activeClass);
    }

    refresh(): boolean {
        return true;
    }

    @HostListener('keydown', ['$event']) triggerEvent(ev: KeyboardEvent) {
        const params = this.params();
        const icon = this.icon();
        if (!params) return;
        if (ev.altKey === false && ev.shiftKey === false && ev.ctrlKey === false) {
            if (ev.key === 'Enter' || ev.key === ' ') {
                switch (params.matIcon) {
                    case 'playlist_add':
                        {
                            params.onClick();
                            ev.preventDefault();
                        }
                        break;
                    default: {
                        params.onClick(params, icon);
                        ev.preventDefault();
                    }
                }
            }
        }
    }

    onButtonClick(event: MouseEvent) {
        const params = this.params();
        const icon = this.icon();
        if (params && event.detail !== 0) {
            this.onClick(params, icon);
        }
    }
}
